export default "__VITE_ASSET__Bjkj$CLW__"